angular.module('leanlaw').directive('reportPickerClient', ["$rootScope", "$q", "clientMatterManager", "userService", "messageBus", "$filter", function ($rootScope, $q, clientMatterManager, userService, messageBus, $filter) {
  // Sorting here rather than in ng-options, which re-sorted every matter in the firm
  // on every digest. orderBy returns a new array, so the shared clientMatterManager
  // cache these lists come from is not reordered underneath its other callers.
  const byLabel = list => $filter('orderBy')(list, 'label');
  return {
    restrict: 'E',
    scope: {},
    template: require('./views/reportPickerClient.html'),
    link: async ($scope, element, attrs, ctrl) => {
      // Per-instance: the sidebar is created and destroyed per report now, and a
      // factory-scoped array would carry one report's matters into the next.
      let _matters = [];
      let destroyed = false;
      let onClientMatterSet = null;
      $scope.$on("$destroy", () => {
        destroyed = true;
        if (onClientMatterSet) messageBus.removeListener(onClientMatterSet);
      });
      const meLoaded = userService.me().then(me => {
        $scope.me = me;
      });
      const clientsLoaded = clientMatterManager.listClients({
        matters: 'include',
        scope: 'all',
        showSecondarySplitMatter: true
      }).then(clients => {
        $scope.clients = byLabel(clients);
      });
      const mattersLoaded = clientMatterManager.listMatters({
        scope: 'all',
        showSecondarySplitMatter: true
      }).then(matters => {
        _matters = byLabel(matters);
        $scope.matters = _matters;
      });
      await $q.all([meLoaded, clientsLoaded, mattersLoaded]);

      // Torn down while the client/matter fetch was still in flight — registering
      // now would outlive the $destroy that was supposed to remove it.
      if (destroyed) return;
      $scope.changeClient = client => {
        if (client) {
          $scope.matters = byLabel(client.matters);
          if (client.matters.length === 1) {
            $scope.cm.matter = client.matters[0];
          }
        } else {
          $scope.cm.matter = null;
          $scope.matters = _matters;
        }
        $rootScope.$broadcast("report-clientmatter-change", {
          client: $scope.cm.client,
          matter: $scope.cm.matter
        });
      };
      $scope.changeMatter = matter => {
        if (matter) {
          $scope.cm.client = $scope.clients.find(c => c.id === matter.client.id);
          $scope.matters = byLabel($scope.cm.client.matters);
        }
        $rootScope.$broadcast("report-clientmatter-change", {
          client: $scope.cm.client,
          matter: $scope.cm.matter
        });
      };
      onClientMatterSet = cm => {
        $scope.cm = cm;
        if (cm.client) {
          $scope.cm.client = $scope.clients.find(c => c.id === cm.client.id);
          $scope.matters = byLabel($scope.cm.client.matters);
          if ($scope.cm.client.matters.length === 1) {
            $scope.cm.matter = $scope.cm.client.matters[0];
          }
        } else {
          $scope.matters = _matters;
        }
      };
      messageBus.addListener("clientmatter-set", onClientMatterSet);
    }
  };
}]);